import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import { Role } from '@/modules/auth/types';
import router, { ROUTE_NAME_ACTIVITY } from './router';

menuRegistry.registerMenu([
    {
        parent: 'General',
        key: 'Activity',
        name: 'Activity',
        icon: 'fa fa-history',
        route: { name: ROUTE_NAME_ACTIVITY.INDEX },
        roles: [Role.ADMIN]
    }
]);

export default registerRouteForModule(router);
